<div class="hide-in-mobile">
  <div class="container-fluid">
    <div *ngIf="loading">
      <div class="se-loader mrgAuto10"></div>
    </div>
    <div
      class="tbl-data"
      [ngClass]="{
        'support-table-admin': isAdmin === 'false',
        'table-admin': isAdmin === 'true',
        body_Overlay: loading
      }"
    >
      <p-table
        [columns]="cols"
        #dt
        [value]="tickets"
        [responsive]="true"
        [rowsPerPageOptions]="[10, 15, 20]"
        [paginator]="tickets?.length > 10"
        [rows]="10"
      >
        <ng-template pTemplate="caption">
          <div class="row align-items-center">
            <div class="col">
              <div class="input-group mt-2 srchGrp se-inline-form">
                <input
                  type="search"
                  class="se-form-control ml-0"
                  title="{{ labels.applicationSearch }}"
                  placeholder="Search"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                />
                <span class="se-icon-action_search_stroke"></span>
              </div>
            </div>
            <div class="col-auto">
              <div class="mb-one">
                <button
                  class="se-button mr-3"
                  *ngIf="isAdmin === 'false'"
                  (click)="addNewIssue()"
                >
                  {{ labels.addTicket }}
                </button>
                <em
                  class="iconFntPos"
                  title="Download Tickets"
                  [ngClass]="{ icnDisbaled: tickets.length == 0 }"
                  (click)="exportTickets()"
                  ><span
                    class="se-icon-action_download_stroke exportIcon text-bold"
                  ></span
                ></em>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr *ngIf="isAdmin == 'false'">
            <th
              scope="col"
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [ngStyle]="{
                display:
                  col.header != 'Created by' &&
                  col.header != 'Email' &&
                  col.header != 'Assigned To'
                    ? true
                    : 'none',
                width: col.header != 'Description' ? true : '35%'
              }"
            >
              <ng-container
                *ngIf="
                  col.header != 'Created by' &&
                  col.header != 'Email' &&
                  col.header != 'Assigned To'
                "
                >{{ col.header }}</ng-container
              >
              <p-sortIcon
                [field]="col.field"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th scope="col" style="width: 9%">{{ labels.action }}</th>
          </tr>
          <tr *ngIf="isAdmin == 'true'">
            <th
              scope="col"
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [ngStyle]="{ width: col.width }"
            >
              {{ col.header }}
              <p-sortIcon
                [field]="col.field"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th scope="col" style="width: 5%">{{ labels.action }}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          let-i="rowIndex"
        >
          <tr class="mob-tr">
            <ng-container *ngIf="isAdmin == 'false'">
              <td
                *ngFor="let item of columns"
                [ngStyle]="{
                  display:
                    item.field != 'createdBy' &&
                    item.field != 'email' &&
                    item.field != 'assignedTo'
                      ? true
                      : 'none'
                }"
              >
                <span class="txtWordWrap" *ngIf="item.field === 'status'">
                  <span class="p-column-title">{{labels.status}}</span>
                  <span
                    class="se-chip danger"
                    *ngIf="rowData[item.field] === 'Open'"
                    >{{ rowData[item.field] }}</span
                  >
                  <span
                    class="se-chip warning"
                    *ngIf="rowData[item.field] === 'Active'"
                    >{{ rowData[item.field] }}</span
                  >
                  <span
                    class="se-chip se-green"
                    *ngIf="rowData[item.field] === 'Closed'"
                    >{{ rowData[item.field] }}</span
                  >
                </span>
                <span class="txtWordWrap" *ngIf="item.field == 'createdOn'">
                  <span class="p-column-title">{{labels.createdOn}}</span>
                  {{ rowData[item.field] | date: "yyyy-MM-dd  HH:mm:ss" }}
                </span>
                <span class="txtWordWrap" *ngIf="item.field == 'ticketId'">
                  <span class="p-column-title">{{labels.ticketId}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'title'"
                >
                  <span class="p-column-title">{{labels.title}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'description'"
                >
                  <span class="p-column-title">{{labels.description}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'priorityName'"
                >
                {{ rowData[item.field] }}

                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="
                    item.field != 'createdOn' &&
                    item.field != 'status' &&
                    item.field != 'createdBy' &&
                    item.field != 'email' &&
                    item.field != 'assignedTo' &&
                    item.field != 'ticketId' &&
                    item.field !== 'description' &&
                    item.field !== 'title' &&
                    item.field !== 'priorityName'
                  "
                >
                  {{ rowData[item.field] }}
                </span>
              </td>
            </ng-container>
            <ng-container *ngIf="isAdmin == 'true'">
              <td *ngFor="let item of columns">
                <span class="txtWordWrap" *ngIf="item.field === 'status'">
                  <span class="p-column-title">{{labels.status}}</span>
                  <span
                    class="se-chip danger"
                    *ngIf="rowData[item.field] === 'Open'"
                    >{{ rowData[item.field] }}</span
                  >
                  <span
                    class="se-chip warning"
                    *ngIf="rowData[item.field] === 'Active'"
                    >{{ rowData[item.field] }}</span
                  >
                  <span
                    class="se-chip se-green"
                    *ngIf="rowData[item.field] === 'Closed'"
                    >{{ rowData[item.field] }}</span
                  >
                </span>
                <span class="txtWordWrap" *ngIf="item.field == 'createdOn'">
                  <span class="p-column-title">{{labels.createdOn}}</span>
                  {{ rowData[item.field] | date: "yyyy-MM-dd  HH:mm:ss" }}
                </span>
                <span class="txtWordWrap" *ngIf="item.field == 'assignedTo'">
                  <span class="p-column-title">{{labels.assignedTo}}</span>
                  <select
                    class="se-form-control darkgrey-bg"
                    [disabled]="rowData['status'] == 'Closed'"
                    [(ngModel)]="rowData[item.field]"
                    (ngModelChange)="userSelected(rowData, rowData[item.field])"
                  >
                    <option selected value="null" disabled>{{labels.select}}</option>
                    <option *ngFor="let item of adminUsers" value="{{ item }}">
                      {{ item }}
                    </option>
                  </select>
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'description'"
                >
                  <span class="p-column-title">{{labels.description}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'priorityName'"
                >
                {{ rowData[item.field] }}
                </span> 
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field === 'title'"
                >
                  <span class="p-column-title">{{labels.title}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="item.field == 'ticketId'"
                >
                  <span class="p-column-title">{{labels.ticketId}}</span>
                  {{ rowData[item.field] }}
                </span>
                <span
                  class="txtWordWrap"
                  title="{{ rowData[item.field] }}"
                  *ngIf="
                    item.field != 'createdOn' &&
                    item.field != 'status' &&
                    item.field != 'ticketId' &&
                    item.field !== 'description' &&
                    item.field !== 'title' &&
                    item.field !== 'assignedTo' &&
                    item.field !== 'priorityName'
                  "
                >
                  <span class="p-column-title">{{labels.email}}</span>
                  {{ rowData[item.field] }}
                </span>
              </td>
            </ng-container>

            <td class="action_icon">
              <em title="Information"
                ><span
                  (click)="viewTicket(rowData)"
                  class="se-icon-information_stroke"
                ></span
              ></em>
              <em
                *ngIf="isAdmin == 'false'"
                [ngClass]="{ icnDisbaled: rowData.status != 'Open' }"
                title="Delete"
                ><span
                  (click)="delete(rowData.ticketId)"
                  class="se-icon-action_delete"
                ></span
              ></em>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
          <span class="lbl-noitem" *ngIf="tickets.length < 10"
            >0{{ tickets.length }} {{ labels.itemsDisplayed }}</span
          >
          <span class="lbl-noitem" *ngIf="tickets.length >= 10"
            >{{ tickets.length }} {{ labels.itemsDisplayed }}</span
          >
          <span class="lbl-records"> {{ state.rows }} Lines/page</span>
        </ng-template>
      </p-table>
      <div *ngIf="tickets.length == 0">No values to display here</div>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="showModal">
  <div class="se-dialog-holder" style="width: 750px">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ labels.addIssue }}</h3>
    </div>

    <div class="se-dialog-body" [ngClass]="{ body_Overlay: loaderCreate }">
      <div *ngIf="loaderCreate">
        <div class="se-loader"></div>
      </div>
      <div class="se-inline-form">
        <div class="form-ele wid135">
          <label class="se-label vTop text-right" name="title"
            >{{ labels.issueTitle }}<span color="red">*</span></label
          >
          <input
            type="text"
            class="se-form-control"
            maxlength="100"
            (keyup)="validateText($event, 'title')"
            [(ngModel)]="title"
            required
          />
        </div>

        <div class="form-ele wid135">
          <label class="se-label vTop text-right"
            >{{ labels.issueDesc }}<span color="red">*</span></label
          >
          <textarea
            class="se-form-control textarea-resize"
            (keyup)="validateText($event, 'description')"
            name="description"
            required
            maxlength="2500"
            [(ngModel)]="description"
          ></textarea>
          <div class="error files-uploaded wid135">
            <p [hidden]="textValid">{{ errorText }}</p>
          </div>
        </div>
        <div class="form-ele wid135">
          <label class="se-label vTop text-right"
            >{{ labels.issuePriority }}<span color="red">*</span></label>
            <select id="priority" aria-label="priority" class="se-form-control" [(ngModel)]="priority" (change)="onPriorityTicketChange($event.target.value)">
              <option value=""></option>
              <option *ngFor="let item of ticketPriorityList" value="{{item.priorityId}}">{{item.priorityName}}</option>
            </select>
          
        </div>
        <div class="form-ele wid135">
          <label class="se-label vTop text-right"
            >{{ labels.uploadFile }}<span color="red"></span>
            <span class="black--text">{{ labels.imageFormats }}</span>
          </label>
          <div
            class="uploadfilecontainer se-form-control"
            (click)="fileInput.click(); fileInput.value = null"
            appDragDrop
            (onFileDropped)="browseFile($event)"
          >
            <input
              hidden
              type="file"
              #fileInput
              multiple
              (change)="uploadFile($event.target.files)"
              accept="image/x-png,image/jpg,image/jpeg"
            />
            <p class="p-abs">{{ labels.addscreens }}</p>
          </div>

          <div class="files-uploaded wid135 ml-20 hide-in-mobile">
            <span *ngFor="let file of files; let i = index">
              <span class="se-chip" title="{{ file }}"
                >{{ file
                }}<span
                  class="se-icon-action_delete_cross"
                  (click)="deleteAttachment(i)"
                ></span
              ></span>
            </span>
          </div>
          <div class="files-uploaded wid135 ml-0 hide-in-large">
            <span *ngFor="let file of files; let i = index">
              <span class="se-chip" title="{{ file }}"
                >{{ file
                }}<span
                  class="se-icon-action_delete_cross"
                  (click)="deleteAttachment(i)"
                ></span
              ></span>
            </span>
          </div>
          <div class="error files-uploaded wid135">
            <p [hidden]="!fileTypeError">{{ errorSameFile }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeaddModal()">
        {{ labels.cancel }}
      </button>
      <button
        class="se-button"
        (click)="addTicket()"
        [disabled]="!validText.title || !validText.description || !validText.priority"
      >
        {{ labels.add }}
      </button>
    </div>
  </div>
</div>

<!-- Confirmation popup -->
<div class="se-dialog" *ngIf="deletePopup">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{ labels.deleteTicket }}</h3>
    </div>
    <div class="se-dialog-body se-fullpage_style">
      <p>{{ labels.confirmDelete }}</p>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="revertChanges()">
        {{ labels.no }}
      </button>
      <button class="se-button" (click)="saveData()">{{ labels.yes }}</button>
    </div>
  </div>
</div>
<!-- Confirmation popup -->

<div class="se-dialog se-full-page" *ngIf="expandIssue">
  <div class="se-dialog-holder se-dialog-holder_full">
    <div *ngIf="loaderFullPage">
      <div class="se-loader mrgAuto10"></div>
    </div>
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">
        {{ labels.ticketDetails }} : {{ issueId }}
      </h3>
      <span
        (click)="closeFullPage()"
        class="close-icon se-icon-action_close"
      ></span>
    </div>
    <div
      class="se-dialog-body se-fullpage_style"
      [ngClass]="{ body_Overlay: loaderFullPage }"
      style="height: calc(100vh - 103px)"
    >
      <div class="panel-data">
        <div class="mb-32">
          <p class="heading">{{ labels.status }}</p>
          <p>
            <span class="se-chip danger" *ngIf="issueStatus == 'Open'">{{
              issueStatus
            }}</span>
            <span class="se-chip warning" *ngIf="issueStatus == 'Active'">{{
              issueStatus
            }}</span>
            <span class="se-chip se-green" *ngIf="issueStatus == 'Closed'">{{
              issueStatus
            }}</span>
          </p>
        </div>
        <div>
          <p class="heading">{{ labels.issueTitle }}</p>
          <p>{{ issueTitle }}</p>
        </div>
        <div>
          <p class="heading mt-2">{{ labels.issueDesc }}</p>
          <p>{{ issueDesc }}</p>
        </div>
        <div>
          <p class="heading mt-2"> {{ labels.issuePriority }} </p>
          <p>{{ issuePriority }}</p>
        </div>
        <div class="mb-32 mt-2" *ngIf="isAdmin">
          <p class="heading">{{ labels.createdBy }}</p>
          <p>
            {{ createdBy }} - {{ createdEmail }}
            <small> {{ createdDate | date: "yyyy-MM-dd  HH:mm:ss" }} </small>
          </p>
        </div>
        <div class="screenshots mb-32" *ngIf="attachments?.length > 0">
          <p class="heading">{{ labels.attachedFiles }}</p>
          <p class="each-file">
            <span *ngFor="let file of attachments" class="mr-4" style="display: block;">
              <a
                class="downloadLink"
                href="javascript:;"
                (click)="downloadFile(file)"
                >{{ file.value }}
                <span class="se-icon-action_download_stroke text-bold"></span
              ></a>
            </span>
          </p>
        </div>
        <p class="heading">{{ labels.comments }} :</p>
        <div class="comments_div" *ngIf="comments">
          <div class="mb-32" *ngFor="let comment of comments?.reverse()">
            <section
              [ngClass]="{
                'admin-comment': comment.role == 'Admin',
                'user-comment': comment.role == 'User'
              }"
            >
              <div class="section-head se-font-4">
                <strong>{{ comment.addedby }} - {{ comment.email }}</strong>
                <small>
                  ({{ comment.timestamp | date: "yyyy-MM-dd  HH:mm:ss" }} : UTC
                  Time)
                </small>
              </div>
              <div class="section-body se-font-3 p-2">
                {{ comment.comment }}
              </div>
            </section>
          </div>
          <p *ngIf="comments && !comments.length">
            {{ labels.noComments }}
          </p>
        </div>
        <div class="mt-1">
          <p
            class="heading mt-3"
            *ngIf="
              (isAdmin == 'false' && issueStatus == 'Closed') ||
              (isAdmin == 'true' &&
                (issueStatus == 'Open' || issueStatus == 'Active'))
            "
          >
            {{ labels.addComment }}
          </p>
          <textarea
            *ngIf="isAdmin == 'false' && issueStatus == 'Closed'"
            class="se-form-control se-block resolution_text"
            rows="2"
            name="reOpenComment"
            required
            maxlength="2500"
            [(ngModel)]="reOpenComment"
            (keyup)="validateText($event, 'reopen')"
          ></textarea>
          <textarea
            *ngIf="
              isAdmin == 'true' &&
              (issueStatus == 'Open' || issueStatus == 'Active')
            "
            class="se-form-control se-block resolution_text"
            rows="2"
            name="resolution"
            required
            maxlength="2500"
            [(ngModel)]="resolution"
            (keyup)="validateText($event, 'resolution')"
          ></textarea>
          <button
            class="se-button button-primary mt-3"
            *ngIf="isAdmin == 'false' && issueStatus == 'Closed'"
            (click)="confirmReOpen = true"
            [disabled]="!validText.reOpenText"
          >
            {{ labels.reOpenTicket }}
          </button>
          <button
            class="se-button button-primary mt-3"
            (click)="resolveTicket()"
            [disabled]="!validText.resolutionText"
            *ngIf="isAdmin == 'true' && issueStatus !== 'Closed'"
          >
            {{ labels.resolveTicket }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation popup -->
  <div class="se-dialog" *ngIf="confirmResolve">
    <div class="se-dialog-holder">
      <div class="se-complex-header">
        <h3 class="se-dialiog-title">{{ labels.resolveTicket }}</h3>
      </div>
      <div class="se-dialog-body se-fullpage_style">
        <p>{{ labels.confirmResolve }}</p>
      </div>
      <div class="se-dialog-footer">
        <button class="se-button" (click)="cancelResolve()">
          {{ labels.no }}
        </button>
        <button class="se-button" (click)="saveResolution()">
          {{ labels.yes }}
        </button>
      </div>
    </div>
  </div>
  <!-- Confirmation popup -->

  <!-- Confirmation popup -->
  <div class="se-dialog" *ngIf="confirmReOpen">
    <div class="se-dialog-holder">
      <div class="se-complex-header">
        <h3 class="se-dialiog-title">{{ labels.reOpenTicket }}</h3>
      </div>
      <div class="se-dialog-body se-fullpage_style">
        <p>{{ labels.confirmReOpen }}</p>
      </div>
      <div class="se-dialog-footer">
        <button class="se-button" (click)="confirmReOpen = false">
          {{ labels.no }}
        </button>
        <button class="se-button" (click)="saveReOpenCmt()">
          {{ labels.yes }}
        </button>
      </div>
    </div>
  </div>
  <!-- Confirmation popup -->
</div>

<div class="hide-in-large">
  <div class="mobile-support">
    <div class="container-fluid">
      <div *ngIf="loading">
        <div class="se-loader mrgAuto10"></div>
      </div>
      <div class="row mt-3 align-items-center srchDownload" *ngIf="isAdmin === 'false'">
        <div class="col">
          <div class="input-group mt-2 srchGrp se-inline-form">
            <input
              type="search"
              class="se-form-control ml-0"
              title={{labels.applicationSearch}}
              placeholder="Search"
              [(ngModel)]="searchText"
              id="search"
            />
            <span class="se-icon-action_search_stroke"></span>
          </div>
        </div>
        <div class="col-auto">
          <div class="mb-one">
            <button
              class="se-button mr-3 button-primary"
              (click)="addNewIssue()"
            >
              {{ labels.addTicket }}
            </button>
            <em
              class="iconFntPos"
              title="Download Tickets"
              [ngClass]="{ icnDisbaled: tickets.length == 0 }"
              (click)="exportTickets()"
              ><span
                class="se-icon-action_download_stroke exportIcon text-bold"
              ></span
            ></em>
          </div>
        </div>
      </div>
      <div class="row mt-3 align-items-center srchDownload" *ngIf="isAdmin === 'true'">
        <div class="col">
          <div class="input-group mt-2 srchGrp se-inline-form">
            <input
              type="search"
              class="se-form-control ml-0"
              title={{labels.applicationSearch}}
              placeholder="Search"
              [(ngModel)]="searchText"
              id="search"
            />
            <span class="se-icon-action_search_stroke"></span>
          </div>
        </div>
        <div class="col-auto">
          <div class="mb-one">
            <em
              class="iconFntPos"
              title="Download Tickets"
              [ngClass]="{ icnDisbaled: tickets.length == 0 }"
              (click)="exportTickets()"
              ><span
                class="se-icon-action_download_stroke exportIcon text-bold"
              ></span
            ></em>
          </div>
        </div>
      </div>
      <div *ngIf="!loading">
        <div class="row fixedSupportLegends">
          <div class="col text-center">
            <p class="status">
              <span class="color danger"></span>
              <span>{{ labels.open }}</span>
            </p>
          </div>
          <div class="col text-center">
            <p class="status">
              <span class="color warning"></span>
              <span>{{labels.active}}</span>
            </p>
          </div>
          <div class="col text-center">
            <p class="status">
              <span class="color se-green"></span>
              <span>{{labels.closed}}</span>
            </p>
          </div>
        </div>
        
        <div class="row" style="margin-top: 63px;">
          <div
            class="card-mobile support-card"
            *ngFor="let item of tickets | filter:searchText"
            [ngClass]="{
              danger: item.status === 'Open',
              warning: item.status === 'Active',
              'se-green': item.status === 'Closed'
            }"
          >
            <div class="row">
              <div class="col-6">
                <p>{{labels.ticketId}}</p>
                <p class="main-t">{{ item.ticketId }}</p>
              </div>
              <div class="col-6">
                <p>{{labels.assignedTo}}</p>
                <div class="txtWordWrap" *ngIf="isAdmin === 'false'">
                  <p class="main-t">{{ item.assignedTo || "-" }}</p>
                </div>
                <div *ngIf="isAdmin !== 'false'">
                  <div class="txtWordWrap" *ngIf="item.assignedTo">
                    <select
                      class="se-form-control darkgrey-bg"
                      [disabled]="item['status'] == 'Closed'"
                      [(ngModel)]="item.assignedTo"
                      (ngModelChange)="userSelected(item, item.assignedTo)"
                    >
                      <option selected value="null" disabled>Select</option>
                      <option
                        *ngFor="let item of adminUsers"
                        value="{{ item }}"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="txtWordWrap" *ngIf="!item.assignedTo">
                    <select
                      class="se-form-control darkgrey-bg"
                      [disabled]="item['status'] == 'Closed'"
                      [(ngModel)]="item.assignedTo"
                      (ngModelChange)="userSelected(item, item.assignedTo)"
                    >
                      <option selected value="null" disabled>Select</option>
                      <option
                        *ngFor="let item of adminUsers"
                        value="{{ item }}"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="item.title">
              <div class="col-6">
                <p>{{labels.title}}</p>
                <p class="main-t" style="word-break: break-word">{{ item.title }}</p>
              </div>
              <div class="col-6">
                <p>{{labels.issuePriority}}</p>
                <p class="main-t wordBreak">{{ item.priorityName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p>{{labels.createdOn}}</p>
                <p class="main-t mb-0">{{ item.createdOn | date: "yyyy-MM-dd  HH:mm:ss" }}</p>
              </div>
              <div class="col-6 act-icons" style="max-width: 100px">
                <p>{{labels.action}}</p>
                <p class="main-t mb-0">
                  <em title="Information"
                    ><span
                      (click)="viewTicket(item)"
                      class="se-icon-information_stroke"
                    ></span
                  ></em>
                  <em *ngIf="isAdmin == 'false'" [ngClass]="{ icnDisbaled: item.status != 'Open' }" title="Delete"
                    ><span
                      (click)="delete(item.ticketId)"
                      class="se-icon-action_delete"
                    ></span
                  ></em>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
